<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#7bff76" type="timer" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>

<div class="card card-primary card-outline card-tabs">
  <div class="card-header p-0 pt-1">
    <h3 class="ggPrompt w3-padding w3-text-blue">
      <mat-icon>fire_truck</mat-icon> BRD คุณภาพอ้อยหน้าลาน
    </h3>
    <ul class="nav nav-tabs no-print" id="custom-tabs-one-tab" role="tablist">
      <li class="nav-item">
        <a class="nav-link active" id="custom-tabs-one-home-tab" data-toggle="pill" href="#custom-tabs-one-home"
          role="tab" aria-controls="custom-tabs-one-home" aria-selected="true">หน้าหลัก</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" id="custom-tabs-one-profile-tab" data-toggle="pill" href="#custom-tabs-one-profile"
          role="tab" aria-controls="custom-tabs-one-profile" aria-selected="false">ข้อมูล</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" id="custom-tabs-one-messages-tab" data-toggle="pill" href="#custom-tabs-one-messages"
          role="tab" aria-controls="custom-tabs-one-messages" aria-selected="false">การแก้ไข</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" id="custom-tabs-one-settings-tab" data-toggle="pill" href="#custom-tabs-one-settings"
          role="tab" aria-controls="custom-tabs-one-settings" aria-selected="false">...</a>
      </li>
    </ul>
  </div>
  <div class="card-body">
    <div class="tab-content" id="custom-tabs-one-tabContent">
      <div class="tab-pane fade show active" id="custom-tabs-one-home" role="tabpanel"
        aria-labelledby="custom-tabs-one-home-tab">
        <h5 class="card-title ggPrompt">
          <mat-icon>search</mat-icon> ค้นหาข้อมูลใบคิว
        </h5>
        <!-- Search Form -->
        <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
          <mat-form-field appearance="outline">
            <mat-label>ป้อนทะเบียน</mat-label>
            <input matInput placeholder="ทะเบียนรถ" formControlName="searchTerm" [(ngModel)]="searchTerm"
              (keydown.enter)="onSearch()" />
            <button mat-icon-button matSuffix (click)="onSearch()">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </form>

        <div class="table-responsive">
          <!-- ตาราง ผลการค้นหาใบคิว -->
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th>
                  ทะเบียนรถ | เจ้าของอ้อย
                </th>
              </tr>
            </thead>
            <tbody *ngFor="let item of searchResults">
              <tr data-widget="expandable-table" aria-expanded="false">
                <td>
                  <button mat-button (click)="openForm()">
                    <mat-icon>post_add</mat-icon>
                  </button>
                  <strong>{{ item.REGTRUCK }} | {{ item.fmname }} </strong>
                </td>
              </tr>
              <tr class="expandable-body">
                <td colspan="1">
                  <p class="horizontal-scroll">
                    เลขใบคิว {{ item.truck_q }} รอบที่ {{ item.ref_doc1 }} คิวที่ {{ item.q_id }} กลุ่มคิว
                    {{ item.groupcode }} เลขแปลง {{ item.landno }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>

        </div>

      </div>
      <div class="tab-pane fade" id="custom-tabs-one-profile" role="tabpanel"
        aria-labelledby="custom-tabs-one-profile-tab">
        <div class="card card-outline card-primaty">
          <div class="card-header no-print sticky">
            <div class="card-tools">
              <mat-form-field appearance="fill" style="width: 180px;">
                <mat-label>เลือกวันที่</mat-label>
                <input matInput name="reportdate" [(ngModel)]="selectedDate" #reportdateInput="ngModel"
                  [matDatepicker]="picker" (dateChange)="onDateChange($event)" required>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="reportdateInput.invalid && reportdateInput.touched">
                  กรุณาเลือกวันที่
                </mat-error>
              </mat-form-field>
              <button *ngIf="selectedDate" (click)="getCanequalityData()" type="button" class="btn btn-tool">
                <i class="fas fa-user-check"></i>
              </button>
              <!-- <button type="button" class="btn btn-tool" data-card-widget="card-refresh" data-source="widgets.html"
                data-source-selector="#card-refresh-content" data-load-on-init="false">
                <i class="fas fa-sync-alt"></i>
              </button> -->
              <button type="button" class="btn btn-tool" data-card-widget="maximize">
                <i class="fas fa-expand"></i>
              </button>
              <!-- <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button> -->
              <button (click)="printPage()" type="button" class="btn btn-tool" data-card-widget="">
                <i class="fas fa-print"></i>
              </button>
              <!-- <button type="button" class="btn btn-tool" data-card-widget="remove">
                <i class="fas fa-times"></i>
              </button> -->
            </div>
            <!-- /.card-tools -->
          </div>
          <!-- /.card-header -->
          <div #captureDiv class="card-body p-0 print">
            <div class="row">
              <div class="col">
                <h5 class="card-title ggPrompt w3-padding">
                  <mat-icon>info</mat-icon> ข้อมูลอ้อยไม่ได้คุณภาพ {{ dateLabel }}
                </h5>
              </div>
            </div>

            <div *ngFor="let item of canequalityData" class="row w3-padding">
              <div class="border" style="page-break-inside: avoid;">
                <!-- <header class="w3-container w3-blue">
                  <h1>{{ item.fmname }}</h1>
                </header> -->
                <div class="row justify-content-md-center">
                  <div class="col-4">
                    <img class="img-01" mat-card-image [src]="item.dc_imageUrl" alt="รูปภาพ">
                  </div>
                  <div class="col-5">
                    <p>ทะเบียน {{ item.regtruck }} </p>
                    <p>แปลง No. {{ item.landno }} </p>
                    <p>{{ item.fmname }} </p>
                    <p>กลุ่ม {{ item.groupname }} </p>
                    <p>นอส. {{ item.g_supcode }} {{ item.g_supname }} </p>
                    <div class="direct-chat-msg">
                      <div class="direct-chat-infos clearfix">
                        <span class="direct-chat-name float-left">ห้องคิว</span>
                        <span class="direct-chat-timestamp float-right">{{ item.created_at_th }} </span>
                      </div>
                      <img class="direct-chat-img" src="../../../../assets/images/bsflogo.png" alt="brr">
                      <div class="direct-chat-text">
                        <span class="w3-text-red ggPrompt w3-large">
                          <mat-icon>warning</mat-icon> {{ item.contaminants }}
                        </span>
                        | {{ item.details }}
                      </div>
                    </div>
                    <!-- <footer class="w3-container w3-amber">
                      <span class="w3-text-red ggPrompt w3-large">
                        <mat-icon>warning</mat-icon> {{ item.contaminants }}
                      </span>
                    </footer> -->
                  </div>
                </div>
              </div>

            </div>

            <!-- <div *ngFor="let item of canequalityData" class="row">
              <div class="col-md-12 col-lg-6 col-xl-4">
                <div class="card mb-2 bg-gradient-dark">
                  <img class="card-img-top" [src]="item.dc_imageUrl" alt="brd">
                  <div class="card-img-overlay d-flex flex-column justify-content-end">
                    <h5 class="card-title text-primary text-white">{{ item.fmname }}</h5>
                    <p class="card-text text-white pb-2 pt-1">{{ item.regtruck }}</p>
                    <p class="card-text text-white pb-2 pt-1">{{ item.groupname }}</p>
                    <p class="card-text text-white pb-2 pt-1">{{ item.g_supcode }}</p>
                    <a href="#" class="text-white">{{ item.groupname }}</a>
                  </div>
                </div>
              </div>
            </div> -->

            <!-- <table class="table table-head-fixed text-nowrap table-hover">
              <thead>
                <tr>
                  <th>วัน/เวลา</th>
                  <th>ทะเบียนรถ</th>
                  <th>เจ้าของอ้อย</th>
                  <th>กลุ่ม</th>
                  <th>นอส.</th>
                </tr>
              </thead>
              <tbody *ngFor="let item of canequalityData">
                <tr data-widget="expandable-table" aria-expanded="false">
                  <td>{{ item.created_at_th }}</td>
                  <td>{{ item.regtruck }}</td>
                  <td>{{ item.fmname }}</td>
                  <td>{{ item.groupname }}</td>
                  <td>{{ item.g_supcode }}</td>
                </tr>
                <tr class="expandable-body">
                  <td colspan="5">
                    <p>
                      <img [src]="item.dc_imageUrl" class="w3-border" alt="Alps" style="width: 100px;">
                      <span class="w3-text-red">
                        <mat-icon>warning</mat-icon> {{ item.contaminants }}
                      </span> แปลง No.{{ item.landno }} | กลุ่ม {{ item.groupcode }}  {{ item.detail }}</p>
                  </td>
                </tr>
              </tbody>
            </table> -->
          </div>
          <!-- /.card-body -->
        </div>
      </div>
      <div class="tab-pane fade" id="custom-tabs-one-messages" role="tabpanel"
        aria-labelledby="custom-tabs-one-messages-tab">
        <div class="card card-outline card-success">
          <div class="card-header">
            <h3 class="card-title ggPrompt"><i class="	fas fa-trash"></i> ข้อมูลอ้อยไม่ได้คุณภาพอ้อยที่ตรวจพบ</h3>
            <div class="card-tools">
              <button class="btn btn-sm btn-tool" (click)="ExportExcelData1();">
                <i class="far fa-file-excel"></i>
              </button>
              <button (click)="loadAllCanqualityYear()" type="button" class="btn btn-tool">
                <i class="fas fa-cloud-download-alt"></i>
              </button>
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
            <!-- /.card-tools -->
          </div>
          <!-- /.card-header -->
          <div class="card-body" style="overflow: auto;">

            <ul *ngFor="let c of allcanequalityData" class="w3-ul w3-card-4 w3-margin">
              <li class="w3-bar">
                <!-- <span onclick="this.parentElement.style.display='none'"
                class="w3-bar-item w3-button w3-xlarge w3-right">&times;</span> -->
                <img [src]="c.dc_imageUrl" class="w3-bar-item w3-border" style="width:100px">
                <div class="w3-bar-item">
                  <span class="w3-large ggPrompt">{{c.fmname}} กลุ่ม {{c.groupname}} ทะเบียน {{c.regtruck}}</span><br>
                  <span>แปลง {{c.landno}} ตรวจพบ <span class="w3-text-red"> {{c.contaminants}}</span> | {{c.detail}}
                    <small class="w3-text-blue">เมื่อ {{c.created_at_th}}</small></span>
                  <p>
                    <button (click)="showFormCorrection(true ,c.id)" class="w3-button w3-circle w3-teal w3-margin-right">+</button>
                    <strong class="ggPrompt"><i class="fas fa-user-edit"></i> การแก้ไข |</strong> <small
                      class="w3-text-blue ggSriracha w3-margin-left"> {{ correctionValue }} {{c.correction }} {{c.g_supname }}</small></p>
                </div>
                  <mat-form-field *ngIf="showForm" class="full-width">
                    <mat-label>การแก้ไข</mat-label>
                    <input matInput [(ngModel)]="dataid"/>
                    <input matInput [(ngModel)]="correctionValue"/>
                    <button mat-icon-button matSuffix color="primary" (click)="saveCorrection()">
                      <mat-icon>send</mat-icon>
                    </button>
                  </mat-form-field>
                <!-- <form class="example-form">
                  <mat-form-field class="example-full-width">
                    <mat-label>Address 2</mat-label>
                    <textarea matInput></textarea>
                  </mat-form-field>
                </form> -->
              </li>
            </ul>


            <!-- <table class="table table-sm text-nowrap table-head-fixed" #tb_caneqc>
              <thead>
                <tr>
                  <td></td>
                  <td>วันเวลา</td>
                  <td>กลุ่ม</td>
                  <td>ชื่อ-สกุล</td>
                  <td>ทะเบียน</td>
                  <td>เลขแปลง</td>
                  <td>ตรวจพบ</td>
                  <td>หมายเหตุ</td>
                  <td><i class="fas fa-truck"></i></td>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of allcanequalityData">
                  <td><div class="w3-card-4">
                    <img class="imgList" [src]="c.dc_imageUrl" alt="brd">
                  </div></td>
                  <td>{{c.created_at_th}}</td>
                  <td>{{c.groupname}}</td>
                  <td>{{c.fmname}}</td>
                  <td>{{c.regtruck}}</td>
                  <td>{{c.landno}}</td>
                  <td>{{c.contaminants}}</td>
                  <td>{{c.detail}}</td>
                  <td></td>
                </tr>
              </tbody>
            </table> -->

          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="custom-tabs-one-settings" role="tabpanel"
        aria-labelledby="custom-tabs-one-settings-tab">
        ...
      </div>
    </div>
  </div>
  <!-- /.card -->
</div>
